/*
Colors below need to stay in sync with colors in tailwind.config.js
*/

export default {
  // Main
  white: "#ffffff",
  lightGrey: "#f5f7fa",
  midGrey: "#dfe2e6",
  darkGrey: "#9198a1",
  black: "#1c252f",
  bodyText: "#343d46",
  transparent: "transparent",
  teal: "#47b4b4",
  purple: "#8F73CA",
  orange: "#ff8e58",

  // Career Tags
  blueText: "#1877f2",
  blueBg: "#e7f1fd",

  // Socialie
  socialiePink: "#FC2361",
  socialiePinkHover: "#FF3D71",
  socialieBlue: "#5cc7ea",
  socialieBlueBg: "#eef9fc",

  // Status Indicators
  error: "#db0c0c",
  errorBg: "#ffeded",

  // Brands
  facebook: "#1877f2",
  instagram: "#e73558",
  instagram_basic: "#e73558",
  instagram_graph: "#e73558",
  linkedin: "#2073b0",
  twitter: "#52a8f0",
  whatsAppGreen: "#25D366",

  // Customer stories
  missUniverse: "#e71578",
}
